import {NgModule} from "@angular/core";
import {PitNavigatorComponent} from "./ui/components/pit-navigator/pit-navigator.component";
import {PitNavigationService} from "./services/pit-navigation.service";
import {DxNavigationModule} from "../dx-navigation/dx-navigation.module";
import {RouterModule} from "@angular/router";
import {PitNavigationRoutingModule} from "./pit-navigation-routing.module";
import {CommonModule} from "@angular/common";
import {DxPageMarkupModule} from "../dx-page-markup/dx-page-markup.module";
import {PitCommonModule} from "../pit-common/pit-common.module";


@NgModule({
  declarations: [
    PitNavigatorComponent
  ],
  exports: [
    PitNavigatorComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    DxPageMarkupModule,
    DxNavigationModule,
    PitCommonModule,
    PitNavigationRoutingModule
  ],
  providers: [
    PitNavigationService
  ],
  bootstrap: []
})
export class PitNavigationModule {

}
